module.exports = __webpack_public_path__ + "img/GoogleAds_H.2fba576c.png";